module.exports = __webpack_public_path__ + "media/images/combo-5-iphone-12-all-5bdea23e.png";